class SiteSounds
    extends QueryElement<HTMLElement> {
    
    private readonly _sounds: { [name: string]: HTMLAudioElement } = {};
    
    constructor(obj: HTMLElement) {
        super(obj);
        
        var sounds = this.query("audio").all(a => a);
        for (var sound of sounds)
        {
            var name = sound.getAttr("class");
            if (name === null)
                continue;
            
            this._sounds[name] = sound.get() as HTMLAudioElement;
        }
    }
    
    play(sound: string)
    {
        var foundSound = this._sounds[`sound-${sound}`];
        if (foundSound != null) {
            foundSound.currentTime = 0;
            foundSound.play();
        }
    }
}